import React, { Fragment, useEffect, useState } from 'react';
import man from '../../../assets/images/dashboard/user.png'
import { Link } from 'react-router-dom';
import { Edit } from 'react-feather';
import {ELANA,GeneralManager} from '../../../constant'

function UserPanel (props) {

    console.log("propsprops =======> ", props)
    
    // const user = props.user;

    const url = `${process.env.PUBLIC_URL}/favicon.svg`;

    const [userData, setUserData] = useState(undefined);


    useEffect(() => {

        const user = JSON.parse(localStorage.getItem("user"));

        setUserData(user);
    }, [])
    return (
        <Fragment>
            <div className="sidebar-user text-center">
                <div>
                    <img className="img-60 rounded-circle lazyloaded blur-up" src={url ? url : man} alt="#" />
                    <div className="profile-edit">
                        <Link to={`${process.env.PUBLIC_URL}/users/userEdit`}>
                            <Edit />
                        </Link>
                    </div>
                </div>
                <h6 className="mt-3 f-14">{ userData?.first_name || "" + " " + userData?.last_name || "" }</h6>
                <p>{userData?.role ?? "Admin"}.</p>
            </div>
        </Fragment>
    );
};

export default UserPanel;